<div class="container" [ngClass]="data?.type" *ngIf="open">
	<div class="wrapper">
		<img [src]="getIcon()" alt="banner icon" class="icon" />
		<div class="content">
			<div class="title" *ngIf="data?.title">{{ data?.title }}</div>
			<div class="description" *ngIf="data?.description">{{ data?.description }}</div>
		</div>
	</div>
	<div class="close-button" (click)="close()" *ngIf="showClose">
		<img src="/assets/close.svg" />
	</div>
</div>
